import { useLazyQuery, useMutation } from "@apollo/client";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import {
  Box,
  Card,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  RadioGroup,
  Snackbar,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Button from "../../../../components/Button/Button";
import { ErrorComponent } from "../../../../components/ErrorComponent/ErrorComponent";
import { AccountCard } from "../../../../components/shared/AccountCard/AccountCard";

import { LinkingWaitMessage } from "../../../../components/shared/LinkingWaitMessage/LinkingWaitMessage";
import { LoadingSpinner } from "../../../../components/shared/LoadingSpinner/LoadingSpinner";
import { Spinner } from "../../../../components/shared/LoadingSpinner/Spinner";
import { NeedHelpCard } from "../../../../components/shared/NeedHelpCard/NeedHelpCard";
import ReportIssue from "../../../../components/shared/ReportIssue/ReportIssue";
import { LegacyPaymentErrorPopup } from "../../../../components/shared/UpdateErrorComponent/LegacyPaymentErrorPopup";
import { UpdateErrorComponent } from "../../../../components/shared/UpdateErrorComponent/UpdateErrorComponent";
import {
  CANCEL_PAYMENT,
  CANCELLED,
  // SELECT_PAYMENT_METHOD,
  // AMOUNT_WARNING_MSG,
  // VISA,
  // visa,
  // masterCard,
  COMPLETE_SUCCESS,
  currentDate,
  EXISTING,
  // CREDIT_CARD,
  // BANK,
  // NEW_CARD,
  // NEW_BANK,
  FETCHING_BILLING_DETAILS_MESSAGE,
  GET_PAYMENT_METHODS_CBST_ACTION,
  HYPHEN,
  isAuthenticated,
  LANGUAGE,
  newPayment,
  NOT_FOUND,
  PAYMENT_DESCRIPTION,
  PAYMENT_METHODS_SECURITY_NOTICE,
  PAYMENT_TERMS_URL,
  PAYMENT_TYPE,
  REPORT_SERVICE_ISSUE_ERROR,
  SUCCESS,
  TOKENIZED_BANK,
  TOKENIZED_CARD,
  TOKENIZED_CREDIT,
  UUID_ERROR_MSG_EXISTING_CUSTOMER_PAYMENTS,
  UUID_ERROR_MSG_NEW_CUSTOMER_PAYMENTS,
} from "../../../../Constants/constants";
import {
  setAnotherAmount,
  setApiFailureName,
  setCbstAction,
  setError,
  setIframeOrderId,
  setIframeURL,
  setInactivatePaymentStatus,
  setPaymentError,
  setPaymentMethodsError,
  setSelectedMethod,
} from "../../../../Redux/Slices/PaymentSlice";
import { setpaidAmount } from "../../../../Redux/Slices/PlanDetailsSlice";
import {
  convertToPositive,
  formatNumberWithCommas,
  getBannerMessageByKey,
  getFlags,
  getModifiedDueDate,
  paymentModifiedDate,
  replacePlaceholder,
  splitMessageBybraces,
} from "../../../../Services/helper";
import {
  CardHeading,
  ErrorMessage,
  MakeaPaymentDivider,
  PageGrid,
  // AutoPayDivider,
  PaymentTextField,
  PTypography,
  SecurityNoticeCard,
  StickyBox,
  // RowCenterStack,
  StyledA,
  StyledCard,
  StyledDialog,
  StyledElement,
  StyledFormControlLabel,
  StyledLink,
  StyledRadio,
} from "../../../../Styles/GlobalStyles";
import { PAYMENT_DELAY_WARNING } from "../../../Login/query";
import {
  GET_PAYMENT_METHOD_URL,
  IFRAME_TRANSACTION_ERROR,
  MAKE_A_PAYMENT,
  SCHEDULE_ONE_TIME_PAYMENT,
  SURCHARGE_DETAILS,
} from "../../../Payment/query";
import { GET_PAYMENT_METHODS } from "../../query";
import PaymentType from "../PaymentType/PaymentType";
import SurchargePaymentSummary from "../SurchargePaymentSummary/SurchargePaymentSummary";
import PaymentIframe from "./PaymentIframe";

export const MakeAPayment = ({ billingLoading, getbillingDetails }: any) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userDetails = useSelector((state: any) => state.userInfo);
  const { scrollPosition, makePaymentRoute } = useSelector((state: any) => state.pageInfo);
  const { ndsObj } = useSelector((state: any) => state.customerInfoDetails);
  const customerDetails = useSelector((state: any) => state.customerInfoDetails);
  const { iframeURL, anotherAmount, paymentMethodsError, selectedMethod, error } = useSelector(
    (state: any) => state.paymentDetails
  );
  const {
    currentDueBalance,
    billDueDate,
    paymentsMigrationToNDS,
    isNewCustomer,
    paymentThreshold,
    totalMonthlyCharge,
  } = useSelector((state: any) => state.customerPlanDetails);
  const [isInputLessThanZero, setIsInputLessThanZero] = useState<boolean>(false);
  const [totalBalance, setTotalBalance] = useState<string>("payment");
  const [paymentInput, setPaymentInput] = useState<string>("");
  const [openError, setOpenError] = useState<boolean>(false);
  const [value, setValue] = useState<any>("dueBalance");
  const isNDS = ndsObj?.isNDS || paymentsMigrationToNDS;
  const [buttonId, setButtonId] = useState(isNDS ? "new card" : "new bank");
  const [selectedOption, setSelectedOption] = useState<string>("payNow");
  const [selectedDate, setSelectedDate] = useState<dayjs.Dayjs | null>(null);
  const [saveDate, setSaveDate] = useState<string>("");
  const { cbstKey, envFlags } = useSelector((state: any) => state.userInfo);
  const ENABLE_SURCHARGE = getFlags("enable_surcharge", envFlags);
  const SHOW_REPORT_ISSUE = getFlags("report_service_issue", envFlags);
  const GLOBAL_BANNER = getFlags("show_global_banner", envFlags);
  const [openReportIssue, setOpenReportIssue] = useState(false);
  const [legacyError, setLegacyError] = useState<boolean>(false);
  const [amountExceed, setAmountExceed] = useState<boolean>(false);
  const [excessAmountPopup, setExcessAmountPopup] = useState<boolean>(false);
  const [paymentLimitValue, setPaymentLimitValue] = useState<string>("");
  const [amountErrorMessage, setAmountErrorMessage] = useState("");
  const [paymentSummaryDisplay, setPaymentSummaryDisplay] = useState(false);
  const [iframeResponse, setIframeResponse] = useState<any>({});
  const sideCoreBannerMessages = useSelector(
    (state: any) => state?.sideCoreContent?.bannerMessages
  );
  const PAYMENT_POPUP_MESSAGE = getBannerMessageByKey(
    "excess-payment-amount",
    sideCoreBannerMessages
  );
  const excessPaymentDiscription = splitMessageBybraces(
    PAYMENT_POPUP_MESSAGE?.content?.subheading?.[0]?.text
  );
  const [isRateLimitError, setIsRateLimitError] = useState(false);
  const [PaymentWarningMessage, setPaymentWarningMessage] = useState<any>({
    open: false,
    message: "",
    vertical: "top",
    horizontal: "center",
  });

  const amountwithoutleadingzeros = anotherAmount !== "." && anotherAmount.toString();
  const formattedDate = getModifiedDueDate(billDueDate);
  const price = currentDueBalance ?? 0;
  const { vertical, horizontal } = PaymentWarningMessage;
  const [openCalendar, setOpenCalendar] = useState(false);
  const { activeAccount } = useSelector((state: any) => state?.customerInfoDetails);
  const { givenNameFamilyName } = useSelector((state: any) => state.customerInfoDetails);

  const handleOpenCalendar = () => {
    setOpenCalendar(true);
  };

  const [getPaymentWarningMessage, { data: PaymentWarningMessageData }] = useLazyQuery(
    PAYMENT_DELAY_WARNING,
    {
      onCompleted: (data) => {
        setPaymentWarningMessage({
          ...PaymentWarningMessage,
          open: data.homeScreenMessage?.error,
          message: data.homeScreenMessage?.message,
        });
      },
    }
  );

  const handleCloseSnackBar = () => {
    setPaymentWarningMessage({ ...PaymentWarningMessage, message: "" });
  };

  const handleSuccessPaymentMethods = () => {
    setPaymentMethodsErrorScreen(false);
    !isNDS && setLegacyError(true);
  };
  const [paymentMethodsErrorScreen, setPaymentMethodsErrorScreen] = useState<boolean>(false);

  const handleFailurePaymentMethods = (error: any) => {
    if (error.networkError.result.errors[0]?.message?.toLowerCase()?.includes(NOT_FOUND)) {
      dispatch(setPaymentMethodsError(true));
    } else {
      setPaymentMethodsErrorScreen(true);
      dispatch(setError(error?.networkError?.result?.errors[0]));
      dispatch(setApiFailureName("getPaymentMethods"));
      dispatch(setCbstAction(GET_PAYMENT_METHODS_CBST_ACTION));
      dispatch(setPaymentMethodsError(false));
    }
  };

  const [getPaymentMethods, { loading: paymentMethodsLoading, data: PaymentMethodsData }] =
    useLazyQuery(GET_PAYMENT_METHODS, {
      variables: {
        accountNumber: customerDetails?.accountNumber,
      },
      onCompleted: handleSuccessPaymentMethods,
      onError: (error) => handleFailurePaymentMethods(error),
      fetchPolicy: "network-only",
    });
  const handlePaymentFailure = (error: any) => {
    navigate("/payment/failed");
    if (error) {
      if (error?.networkError?.result?.errors?.[0]?.message?.includes("Payment Unsuccessful")) {
        dispatch(setPaymentError(error?.networkError?.result?.errors?.[0]?.message));
      }
      dispatch(setError(error?.networkError?.result?.errors?.[0]));
    } else {
      dispatch(setPaymentError(""));
    }
  };

  const [scheduleOnetimePayment, { loading: oneTimePaymentLoading }] = useMutation(
    SCHEDULE_ONE_TIME_PAYMENT,
    {
      onCompleted: (data) => {
        setOpenError(data?.scheduleOneTimePayment?.error);
        getbillingDetails();
      },
      onError: (error) => {
        handlePaymentFailure(error);
      },
    }
  );

  const handleFailurePaymentURL = (URLError: any) => {
    if (URLError) {
      if (URLError?.networkError?.result?.errors[0]?.code === "429") {
        setOpenError(false);
        setOpenReportIssue(true);
        setIsRateLimitError(true);
      } else {
        setOpenError(true);
      }
    }
  };

  const handleSuccessPaymentURL = (URLData: any) => {
    dispatch(setIframeURL(URLData?.getAddPaymentMethodURL?.url));
    dispatch(setIframeOrderId(URLData?.getAddPaymentMethodURL?.orderId));
    setOpenError(URLData?.getAddPaymentMethodURL?.error);
  };
  const checkAmount =
    totalBalance === newPayment
      ? anotherAmount > 0 && parseFloat(anotherAmount.toString()).toFixed(2)
      : parseFloat(convertToPositive(price).toString()).toFixed(2);

  const getAddPaymentMethodURLInput = {
    paymentType: paymentInput,
    billingName: `${givenNameFamilyName?.givenName ?? ""} ${givenNameFamilyName?.familyName ?? ""}`,
    email: userDetails?.email,
    language: LANGUAGE,
    cancelURL: `${window.location.href}?status=failure`,
    successURL: `${window.location.href}?status=success`,
    date: paymentModifiedDate(currentDate),
    completePayment: true,
    amount:
      totalBalance === newPayment
        ? anotherAmount > 0 && parseFloat(parseFloat(anotherAmount).toFixed(2))
        : convertToPositive(parseFloat(price)?.toFixed(2)),
    isNds: ndsObj?.isNDS || paymentsMigrationToNDS,
  };

  const [getPaymentMethodURL, { loading: urlLoading }] = useMutation(GET_PAYMENT_METHOD_URL, {
    variables: {
      accountNumber: customerDetails?.accountNumber,
      addPaymentMethodInput: getAddPaymentMethodURLInput,
    },
    fetchPolicy: "network-only",
    onCompleted: (URLData) => handleSuccessPaymentURL(URLData),
    onError: (URLError) => handleFailurePaymentURL(URLError),
  });

  const [makeAPayment, { loading: paymentLoading }] = useMutation(MAKE_A_PAYMENT, {
    onCompleted: () => {
      navigate("/payment/success");
      getbillingDetails();
    },
    onError: (error: any) => {
      dispatch(setError(error?.networkError?.result?.errors?.[0]));
      handlePaymentFailure(error);
    },
  });
  const [iframeTransactionError] = useMutation(IFRAME_TRANSACTION_ERROR, {
    onError: (error) => console.log(error),
  });
  const [getSurchargeDetails, { loading: surchargeLoading, data: surchargeDetails }] =
    useLazyQuery(SURCHARGE_DETAILS);
  const handleChange = (event: any) => {
    const selectedValue = (event.target as HTMLInputElement).value;
    setValue(selectedValue);
    setTotalBalance(selectedValue);
    dispatch(setAnotherAmount(0));
    setIsInputLessThanZero(false);
    setAmountExceed(false);
  };
  const paymentMethods: any = PaymentMethodsData?.paymentMethods?.paymentDetails;

  const handleFilterPaymentMethod =
    paymentMethods && paymentMethods?.filter((method: any) => method?.id === buttonId);

  const filteredPaymentMethod = handleFilterPaymentMethod?.[0];

  const scheduleOneTimePaymentInput = {
    paymentMethodId: filteredPaymentMethod?.id,
    paymentMethodType: filteredPaymentMethod?.paymentMethodType,
    amount: checkAmount,
    description: PAYMENT_DESCRIPTION,
    nickName: filteredPaymentMethod?.nameOnTheCard,
    date: paymentModifiedDate(currentDate),
    token: filteredPaymentMethod?.token,
    isNds: ndsObj?.isNDS,
    billingAccountId: filteredPaymentMethod?.billingAccountId,
    paymentChannel: "myaccount",
    surchargePayment: ENABLE_SURCHARGE,
  };

  const handlePayment = async () => {
    if (paymentSummaryDisplay) {
      dispatch(setAnotherAmount(surchargeDetails?.getSurchargeDetails?.totalAmountWithTax));
      if (paymentInput === EXISTING) {
        handleOnetimePayment();
      } else {
        handleMakePayment(
          iframeResponse?.content?.uid ? iframeResponse?.content?.uid : iframeResponse?.uid,
          iframeResponse?.txn_guid,
          ndsObj?.isNDS || paymentsMigrationToNDS ? TOKENIZED_CREDIT : TOKENIZED_BANK
        );
      }
      setPaymentSummaryDisplay(false);
    } else {
      if (Number(anotherAmount) > Number(paymentLimitValue)) {
        setExcessAmountPopup(true);
        return;
      }
      proceedWithPayment();
    }
  };

  const proceedWithPayment = async () => {
    setExcessAmountPopup(false);

    if (paymentInput === EXISTING) {
      if (ENABLE_SURCHARGE) {
        try {
          const response = await getSurchargeDetails({
            variables: {
              accountNumber: customerDetails?.accountNumber,
              amount: checkAmount,
              uid: "",
              paymentMethodId: filteredPaymentMethod?.id,
              paymentId: filteredPaymentMethod?.token,
            },
          });
          if (
            !response?.data?.getSurchargeDetails?.error &&
            response?.data?.getSurchargeDetails?.isTaxable
          ) {
            setPaymentSummaryDisplay(true);
          } else {
            handleOnetimePayment();
          }
        } catch (e) {
          handleOnetimePayment();
        }
      } else {
        handleOnetimePayment();
      }
    } else {
      if (isNDS) {
        getPaymentMethodURL();
      } else {
        setLegacyError(true);
      }
    }
  };
  const handleSuccess = async (data: any, uid: any, logPayload: any) => {
    setIframeResponse({ ...data, uid });
    const requestId = sessionStorage.getItem("addPaymentMethodRequestId");
    if (logPayload) {
      logPayload.markedToSave = "todo";
    }
    if (
      (ndsObj?.isNDS || paymentsMigrationToNDS) &&
      (data?.content?.status === SUCCESS || data?.subject === "completePayment")
    ) {
      if (
        (ndsObj?.isNDS || paymentsMigrationToNDS) &&
        buttonId === "new card" &&
        ENABLE_SURCHARGE
      ) {
        try {
          const response = await getSurchargeDetails({
            variables: {
              accountNumber: customerDetails?.accountNumber,
              amount: checkAmount,
              uid: data?.content?.uid ?? uid,
              paymentMethodId: "",
              paymentId: "",
            },
          });
          // if(!response?.data?.getSurchargeDetails?.error){
          //   logPayload.paymentTypeEvaluated = response?.data?.getSurchargeDetails?.paymentType;
          //   const encryptedPayload = encryptPayload(logPayload, cbstKey);
          //   iframeTransactionError({
          //     variables: {
          //       transactionId: requestId,
          //       payload: encryptedPayload,
          //       saveResponse: true,
          //     },
          //   });
          // }
          if (
            !response?.data?.getSurchargeDetails?.error &&
            response?.data?.getSurchargeDetails?.isTaxable
          ) {
            dispatch(setIframeOrderId(""));
            dispatch(setIframeURL(""));
            setPaymentSummaryDisplay(true);
          } else {
            handleMakePayment(data?.content?.uid ? data?.content?.uid : uid, data?.txn_guid);
          }
        } catch (e) {
          handleMakePayment(data?.content?.uid ? data?.content?.uid : uid, data?.txn_guid);
        }
      } else {
        // logPayload.paymentTypeEvaluated = "ACH";
        // const encryptedPayload = encryptPayload(logPayload, cbstKey);
        // iframeTransactionError({
        //   variables: {
        //     transactionId: requestId,
        //     payload: encryptedPayload,
        //     saveResponse: true,
        //   },
        // });
        handleMakePayment(data?.content?.uid ? data?.content?.uid : uid, data?.txn_guid);
      }
    } else if (!ndsObj?.isNDS && data.status === COMPLETE_SUCCESS) {
      navigate({ pathname: "/payment/success" }, { state: { data: "", error: false } });
    }
    dispatch(setIframeOrderId(""));
    dispatch(setIframeURL(""));
  };

  const handleFailure = (data: any) => {
    if (data?.subject === CANCEL_PAYMENT || data?.status === CANCELLED) {
      navigate({ pathname: "/payment/failed" }, { state: { data: data } });
      dispatch(setPaymentError(""));
    }
    dispatch(setIframeOrderId(""));
    dispatch(setIframeURL(""));
  };

  const handleOnetimePayment = async () => {
    dispatch(setpaidAmount(""));
    try {
      const response = await scheduleOnetimePayment({
        variables: {
          accountNumber: customerDetails?.accountNumber,
          scheduleOneTimePaymentInput: scheduleOneTimePaymentInput,
        },
      });
      if (!response?.data?.scheduleOneTimePayment?.error) {
        dispatch(setpaidAmount(scheduleOneTimePaymentInput?.amount));
        response?.data &&
          navigate(
            { pathname: "/payment/success" },
            {
              state: {
                error: false,
                scheduleOneTimePaymentInput: scheduleOneTimePaymentInput,
                isNewPaymentMethod: false,
              },
            }
          );
        if (!activeAccount) {
          dispatch(setInactivatePaymentStatus(true));
        } else {
          dispatch(setInactivatePaymentStatus(false));
        }
        dispatch(setSelectedMethod(""));
      } else {
        navigate("/payment/failed");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAnotherAmount = (e: React.BaseSyntheticEvent) => {
    let input = e.target.value;
    input = input.replace(/[^0-9.]+/g, "");

    const parts = input.split(".");
    if (parts.length > 1) {
      input = `${parts[0]}.${parts[1].slice(0, 2)}`;
    }

    const numericInput = parseFloat(input);
    const limit = parseFloat(paymentLimitValue) * 3;

    dispatch(setAnotherAmount(input));

    const isLessThanOne = numericInput < 1;
    const isExceedingLimit = numericInput > limit;

    if (isLessThanOne) {
      setAmountErrorMessage("Amount must be more than $1");
      setIsInputLessThanZero(true);
      setAmountExceed(false);
      return;
    }

    if (isExceedingLimit) {
      const errorInline = replacePlaceholder(
        PAYMENT_POPUP_MESSAGE?.content?.subheading?.[1]?.text,
        "<amount>",
        limit?.toString()
      );
      setAmountErrorMessage(errorInline);
      setAmountExceed(true);
      setIsInputLessThanZero(false);
      return;
    }

    setAmountErrorMessage("");
    setIsInputLessThanZero(false);

    if (activeAccount === false) {
      setAmountExceed(numericInput > parseFloat(price));
    } else {
      setAmountExceed(false);
    }
  };
  const handleMakePayment = async (uid: any, transactionId: any, paymentMethodType?: string) => {
    try {
      const makePaymentinput = {
        isNds: ndsObj?.isNDS,
        id: uid,
        paymentType: PAYMENT_TYPE,
        paymentMethodType: paymentInput,
        amount: checkAmount,
        date: paymentModifiedDate(currentDate),
        description: PAYMENT_DESCRIPTION,
        savePaymentInfo: false,
        completePayment: true,
        paymentChannel: "myaccount",
        surcharge: ENABLE_SURCHARGE,
      };
      const response = await makeAPayment({
        variables: {
          accountNumber: customerDetails?.accountNumber,
          makeAPaymentInput: makePaymentinput,
        },
      });
      if (response?.data?.makeAPayment?.error) {
        navigate("/payment/failed");
      } else if (response?.data) {
        navigate(
          { pathname: "/payment/success" },
          {
            state: {
              data: transactionId,
              error: false,
              makePaymentInput: makePaymentinput,
              isNewPaymentMethod: true,
            },
          }
        );
        dispatch(setSelectedMethod(""));
      }
    } catch (err) {
      console.log(err);
    }
  };

  const isAnotherAmountValid = anotherAmount <= 0 || anotherAmount === ".";

  const payButtonEventName =
    paymentInput === TOKENIZED_BANK || paymentInput === TOKENIZED_CREDIT ? "continue" : "payment";

  const payButtonTitle =
    paymentSummaryDisplay && surchargeDetails?.getSurchargeDetails?.totalAmountWithTax
      ? `PROCEED TO PAY`
      : paymentInput === TOKENIZED_BANK || paymentInput === TOKENIZED_CREDIT
        ? "CONTINUE"
        : anotherAmount
          ? `Pay ${formatNumberWithCommas(amountwithoutleadingzeros)}`
          : (price && price?.includes("-")) || totalBalance === newPayment
            ? "Pay"
            : `Pay ${formatNumberWithCommas(price)}`;

  const payButtonDisable =
    isInputLessThanZero ||
    amountExceed ||
    (price && (price?.includes("-") || price == 0) && isAnotherAmountValid) ||
    (totalBalance === newPayment && isAnotherAmountValid) ||
    billingLoading;

  useEffect(() => {
    getPaymentWarningMessage();
    dispatch(setIframeOrderId(""));
    dispatch(setIframeURL(""));
    dispatch(setAnotherAmount(0));
    if (currentDueBalance <= 0) {
      setPaymentLimitValue(totalMonthlyCharge);
    } else {
      setPaymentLimitValue(currentDueBalance);
    }
  }, []);

  useEffect(() => {
    setValue("dueBalance");
    customerDetails?.accountNumber?.trim()?.length > 0 &&
      isAuthenticated === "FALSE" &&
      getPaymentMethods();
  }, [customerDetails?.accountNumber]);

  useEffect(() => {
    customerDetails?.accountNumber?.trim()?.length > 0 &&
      isAuthenticated === "FALSE" &&
      getPaymentMethods();
  }, [customerDetails?.accountNumber]);
  useEffect(() => {
    if (!paymentSummaryDisplay) {
      if (buttonId === "new card") {
        setPaymentInput(TOKENIZED_CREDIT);
      } else if (buttonId === "new bank") {
        setPaymentInput(TOKENIZED_BANK);
      } else {
        setPaymentInput(EXISTING);
      }
    }
  }, [buttonId]);

  // Scroll to top when iframeURL is set
  useEffect(() => {
    if (iframeURL?.length > 0) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [iframeURL]);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedOption((event.target as HTMLInputElement).value);
  };

  const handleDateChange = (date: dayjs.Dayjs | null) => {
    setSelectedDate(date);
  };

  const handleSaveDate = () => {
    if (selectedDate) {
      setSaveDate(selectedDate.format("MM/DD/YYYY"));
    }
    setOpenCalendar(false);
  };
  const handleCloseCalendar = () => {
    setOpenCalendar(false);
    setSelectedDate(null);
  };
  const handleRefresh = () => {
    getPaymentMethods({ fetchPolicy: "network-only" });
  };
  const handlePaymentSummaryBack = () => {
    setPaymentSummaryDisplay(false);
  };
  const handleManagePaymentMethods = () => {
    navigate("/account", { state: { scrollToPaymentMethods: true } });
  };

  return (
    <Box position="relative">
      {GLOBAL_BANNER &&
        PaymentWarningMessage?.message &&
        PaymentWarningMessageData?.homeScreenMessage?.error &&
        PaymentWarningMessageData?.homeScreenMessage?.paymentScreen && (
          <Box sx={{ width: 500 }}>
            <Snackbar
              action={
                <>
                  <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={handleCloseSnackBar}>
                    <DeleteForeverIcon fontSize="small" />
                  </IconButton>
                </>
              }
              sx={{
                textAlign: "center",
              }}
              anchorOrigin={{ vertical, horizontal }}
              open={PaymentWarningMessage?.message?.length > 0}
              message={PaymentWarningMessage?.message}
              key={vertical + horizontal}
              autoHideDuration={100000}
              onClose={handleCloseSnackBar}
            />
          </Box>
        )}
      <PageGrid container>
        <Grid item xs={12} lg={8.2}>
          <StyledLink to={makePaymentRoute}>
            <Stack direction={"row"} alignItems="center">
              <ArrowBackIosIcon color="secondary" />
              <CardHeading>Make a payment</CardHeading>
            </Stack>
          </StyledLink>
          {!paymentMethodsError ? (
            <>
              {paymentSummaryDisplay && surchargeDetails ? (
                <>
                  <CardHeading mt={2}>Total balance</CardHeading>

                  <SurchargePaymentSummary
                    taxAmount={surchargeDetails?.getSurchargeDetails?.taxAmount}
                    totalAmountWithTax={surchargeDetails?.getSurchargeDetails?.totalAmountWithTax}
                    enteredAmount={checkAmount}
                  />
                </>
              ) : (
                !(iframeURL?.length > 0) && (
                  <>
                    <CardHeading mt={2}>Total balance</CardHeading>
                    <StyledCard sx={{ paddingX: "20px" }}>
                      {billingLoading ? (
                        <Box py={10}>
                          <Spinner loadingText={FETCHING_BILLING_DETAILS_MESSAGE} />
                        </Box>
                      ) : (
                        <FormControl fullWidth>
                          <RadioGroup
                            aria-labelledby="demo-controlled-radio-buttons-group"
                            name="controlled-radio-buttons-group"
                            value={value}
                            onChange={handleChange}>
                            <Stack
                              alignItems={{ xs: "flex-start", sm: "center" }}
                              justifyContent={"space-between"}
                              direction={{ xs: "column", sm: "row" }}>
                              <StyledFormControlLabel
                                disabled={iframeURL?.length > 0}
                                value={"dueBalance"}
                                control={<StyledRadio />}
                                label={`${formatNumberWithCommas(price ?? 0)}`}
                              />
                              <PTypography marginLeft={"30px"}>
                                {billDueDate &&
                                  `Current balance due ${billDueDate ? formattedDate : "-"}`}
                              </PTypography>
                            </Stack>
                            <MakeaPaymentDivider />
                            <StyledFormControlLabel
                              disabled={iframeURL?.length > 0}
                              value={newPayment}
                              control={<StyledRadio />}
                              label="Pay another amount"
                            />

                            {(totalBalance === newPayment ||
                              (price?.toString()?.includes(HYPHEN) && value == newPayment)) &&
                              value == newPayment && (
                                <PaymentTextField
                                  error={isInputLessThanZero || amountExceed}
                                  disabled={iframeURL?.length > 0}
                                  name="numberformat"
                                  inputProps={{ "data-testid": "another-amount-textfield" }}
                                  value={anotherAmount !== 0 ? anotherAmount : null}
                                  onChange={handleAnotherAmount}
                                />
                              )}

                            {(isInputLessThanZero || amountExceed) &&
                              anotherAmount !== 0 &&
                              value === newPayment && (
                                <ErrorMessage error={true}>{amountErrorMessage}</ErrorMessage>
                              )}
                          </RadioGroup>
                        </FormControl>
                      )}
                    </StyledCard>
                  </>
                )
              )}
              {/* TODO: Enable Scehedule Payments*/}
              {/* <CardHeading sx={{ fontSize: iframeURL?.length > 0 ? "18px" : "20px" }}>
                Payment date
              </CardHeading>
              <StyledCard sx={{ paddingX: "20px" }}>
                <FormControl fullWidth>
                  <RadioGroup
                    aria-labelledby="payment-radio-buttons-group"
                    name="payment-radio-buttons-group"
                    value={selectedOption}
                    onChange={handleRadioChange}>
                    <StyledFormControlLabel
                      value="payNow"
                      control={<StyledRadio />}
                      label="Pay right now"
                    />
                    <MakeaPaymentDivider />
                    <StyledFormControlLabel
                      control={<StyledRadio />}
                      label={selectedOption === "payNow" ? "Pay later" : "Schedule a Payment"}
                      value="pay Later"
                    />
                  </RadioGroup>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["DatePicker"]}>
                      <DemoItem>
                        <DatePicker
                          disabled={selectedOption === "payNow"}
                          value={selectedDate}
                          onChange={handleDateChange}
                          disablePast
                          views={["year", "month", "day"]}
                          slots={{
                            textField: (params: any) => (
                              <CalendarText
                                {...params}
                                value={selectedDate ? saveDate : ""}
                                InputProps={{
                                  ...params.InputProps,
                                  readOnly: true,
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <CalendarMonthIcon />
                                    </InputAdornment>
                                  ),
                                  endAdornment: null,
                                }}
                                onClick={handleOpenCalendar}
                              />
                            ),
                          }}
                        />
                      </DemoItem>
                    </DemoContainer>
                  </LocalizationProvider>
                  <StyledDialog
                    open={openCalendar}
                    aria-describedby="modal-modal-description"
                    width="100%">
                    <Box mt={3}>
                      <CustomCalendar
                        selectedDate={selectedDate}
                        onDateChange={handleDateChange}
                        minDate={dayjs()}
                        maxDate={dayjs().add(1, "year")}
                      />
                    </Box>
                    <Stack direction={"row"} gap={2} mb={6} justifyContent={"center"}>
                      <Button title={"Save"} onClick={handleSaveDate} type="root" />
                      <Button title={"Cancel"} onClick={handleCloseCalendar} type="cancel" />
                    </Stack>
                  </StyledDialog>
                </FormControl>
              </StyledCard> */}
              {!paymentSummaryDisplay && (
                <>
                  <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                    <CardHeading sx={{ fontSize: iframeURL?.length > 0 ? "18px" : "20px" }}>
                      Payment method
                    </CardHeading>
                    <Button
                      title="MANAGE PAYMENT METHODS"
                      type="root"
                      onClick={handleManagePaymentMethods}
                    />
                  </Stack>
                  {isAuthenticated === "TRUE" && (
                    <SecurityNoticeCard>{PAYMENT_METHODS_SECURITY_NOTICE}</SecurityNoticeCard>
                  )}
                  <PaymentMethodsCard
                    sx={{
                      padding: iframeURL?.length > 0 ? "0.2rem" : "1rem 1.5rem",
                    }}>
                    {!(iframeURL?.length > 0) ? (
                      <PaymentType
                        buttonId={buttonId}
                        setButtonId={setButtonId}
                        paymentMethods={paymentMethods}
                        paymentMethodsLoading={paymentMethodsLoading}
                        paymentMethodsErrorScreen={paymentMethodsErrorScreen}
                      />
                    ) : (
                      <PaymentIframe
                        handleSuccess={handleSuccess}
                        src={iframeURL}
                        handleFailure={handleFailure}
                        paymentType={buttonId === "new bank" ? TOKENIZED_BANK : TOKENIZED_CARD}
                      />
                    )}
                  </PaymentMethodsCard>
                  {paymentMethodsErrorScreen && !(iframeURL?.length > 0) && (
                    <StyledCard>
                      <ErrorComponent
                        onRefresh={handleRefresh}
                        ShowReportIssue={SHOW_REPORT_ISSUE}
                        errorMessage={REPORT_SERVICE_ISSUE_ERROR}
                      />
                    </StyledCard>
                  )}{" "}
                </>
              )}
              <Box my={4}>
                <StyledA href={PAYMENT_TERMS_URL} target="_blank">
                  <StyledElement fontSize={{ xs: "14px", sm: "16px" }}>
                    PAYMENT TERMS & CONDITIONS
                  </StyledElement>
                </StyledA>
              </Box>
              <Stack direction={"row"} gap={2}>
                {paymentSummaryDisplay && (
                  <Button
                    type="back"
                    eventName={"payment_summary_back"}
                    title="BACK"
                    onClick={handlePaymentSummaryBack}
                  />
                )}
                {iframeURL?.length === 0 && (
                  <Button
                    eventName={payButtonEventName}
                    title={payButtonTitle}
                    disabled={payButtonDisable}
                    onClick={handlePayment}
                    type="payment"
                  />
                )}
              </Stack>
            </>
          ) : (
            <StyledCard sx={{ py: 20, pb: 22 }}>
              <LinkingWaitMessage
                message={
                  isNewCustomer
                    ? UUID_ERROR_MSG_NEW_CUSTOMER_PAYMENTS
                    : UUID_ERROR_MSG_EXISTING_CUSTOMER_PAYMENTS
                }
              />
            </StyledCard>
          )}
        </Grid>

        <Grid
          mt={{ xs: "32px", lg: "0" }}
          item
          xs={12}
          lg={3.5}
          display={{ xs: "block", lg: scrollPosition > 200 ? "block" : "none" }}>
          <AccountCard totalBalance={totalBalance} setTotalBalance={setTotalBalance} />
          <NeedHelpCard />
        </Grid>
        <StickyBox display={{ xs: "none", lg: scrollPosition > 200 ? "none" : "block" }}>
          <AccountCard totalBalance={totalBalance} setTotalBalance={setTotalBalance} />
          <NeedHelpCard />
        </StickyBox>
      </PageGrid>
      {(paymentMethodsLoading ||
        urlLoading ||
        paymentLoading ||
        oneTimePaymentLoading ||
        surchargeLoading) && <LoadingSpinner />}
      <ReportIssue
        setOpenDialog={setOpenReportIssue}
        openDialog={openReportIssue}
        isRateLimitError={isRateLimitError}
        setIsRateLimitError={setIsRateLimitError}
      />
      <UpdateErrorComponent openError={openError} setOpenError={setOpenError} />
      <LegacyPaymentErrorPopup openError={legacyError} setOpenError={setLegacyError} />
      <StyledDialog open={excessAmountPopup}>
        <DialogTitle sx={{ textAlign: "center", fontWeight: "bold", fontSize: "1.2rem" }}>
          {PAYMENT_POPUP_MESSAGE?.content?.heading?.[0]?.text}
        </DialogTitle>
        <DialogContent sx={{ textAlign: "center", px: 4 }}>
          <Typography sx={{ fontSize: { xs: "12px", sm: "14px" } }}>
            {excessPaymentDiscription[0]}{" "}
            {replacePlaceholder(excessPaymentDiscription[1], "<Amount>", anotherAmount)}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
          <Box display="flex" gap={2}>
            <Button title={"No Close"} onClick={() => setExcessAmountPopup(false)} type="payment" />
            <Button title={"YES, PROCEED"} onClick={proceedWithPayment} type="payment" />
          </Box>
        </DialogActions>
      </StyledDialog>
    </Box>
  );
};

export const PaymentMethodsCard = styled(Card)(({ theme }) => ({
  boxShadow: "0px 0px 4px 0px rgb(193, 193, 193)",
  elevation: 0,
  borderRadius: 8,
  margin: isAuthenticated === "TRUE" ? "0" : "0.8rem 0 1.5rem 0",
}));
